import { render, staticRenderFns } from "./KelembagaanProvinsi.vue?vue&type=template&id=cc413892"
import script from "./KelembagaanProvinsi.vue?vue&type=script&lang=js"
export * from "./KelembagaanProvinsi.vue?vue&type=script&lang=js"
import style0 from "./KelembagaanProvinsi.vue?vue&type=style&index=0&id=cc413892&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports